export type NavTheme = 'realDark' | 'light';
const STORAGE_KEY = 'cf-admin-nav-theme';

// 没有手动选择时跟随系统；浏览器限制本地存储时仍可在当前页面切换。
export function readThemePreference(): NavTheme | undefined {
  try {
    const value = window.localStorage.getItem(STORAGE_KEY);
    return value === 'light' || value === 'realDark' ? value : undefined;
  } catch {
    return undefined;
  }
}

export function saveThemePreference(value: NavTheme): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, value);
  } catch {
    // 存储不可用不阻止本次主题切换。
  }
}
